var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgoric(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 170,
    rx: 85,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_48_120",
    transform: "scale(0.0025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_48_120",
    width: 400,
    height: 400,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAGQCAMAAAC3Ycb+AAAAnFBMVEX4+PjGlJu7LUDi39/y8fH39/fQvsH09PTEjZTt6+vt7e3Wy8zj4ODk4eHk4uLl4uLl4+Pm4+Pm5OTn5eXWzM3XzM3o5ubp5+fXzc7Yzc7Yzs/Zzs/Zz9DZ0NDGlZy9V2fHlZzHlpzHlp3Hl57Il57ImJ7ImJ/ImZ/JmaC+PE3JmqHKm6LKnKLKnKPLnaPLnaTLnqTLn6X29vby8vKfBAUMAAAClUlEQVR4nO3SSZKQRRRGUVAQRJFGAVGR6qDKhkbd/94kcZBOkwjIyx/nLOANvvuuXQMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+letfBHy5e4UQQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiRHkw9xYcHPl8EqQr24tuH3sICv/9vXK4ZUgd1YOfyOIIJ+QIDGCxAgSI0iMIDGCxAgSI0iMIDGCxAgSI0iMIDGCxAgSI0iMIDHHDvLt2hgFgsQIEiNIjCAxxw5yd22MAkFijh3ku7UxCo4d5N7aGAXHDnJ/bYyCYwd5sDZGwbGDPFwbo0CQmGMH+X5tjILPL8gPgrSCPFo4/HhtjAJBYo4d5MnaGAWCxHx+QX4UpBXkqSCtID8J0grysyCtIL8I0gry7NhBPppfF3Z7fvJ/p++dnZ795/z8/OLi4sWLl+9cXl5d/SbIB1kJ8tEIMp3sjjEIMp3ujjEIMp3tjjEIMp3tjjEIMp3vjjEIMl3sjjEIMr3cHWMQZLrcHWMQZLraHWMQZPp9d4xBkOmP3TEGQaY/d8cYBJle7Y4xCDK93h1jEGR6szvGIMj0dneMQZDpr90xBkEmQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWL+/idg9wgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQ8y9grb6h9r8+1QAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgoric);
export default __webpack_public_path__ + "static/media/agoric.fff876ae360e02929014d7e2d2e97f08.svg";
export { ForwardRef as ReactComponent };